// extracted by mini-css-extract-plugin
export default {"inputField":"SearchInput_inputField__H3wpv","searchWrapper":"SearchInput_searchWrapper__GDo8N","iconWrapper":"SearchInput_iconWrapper__BpokY"};